import { CandidateStatusDto } from '@/api/generated';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import {
  statusTone,
  type StatusTone,
  TONE_STYLES,
} from '@/views/admin/candidates/candidateStatus.ts';
import React from 'react';
import {
  IoAlertCircle,
  IoCheckmarkCircle,
  IoCloseCircle,
  IoEllipse,
  IoHourglassOutline,
} from 'react-icons/io5';

const TONE_ICONS: Record<StatusTone, React.ReactNode> = {
  critical: <IoCloseCircle aria-hidden />,
  good: <IoCheckmarkCircle aria-hidden />,
  neutral: <IoEllipse aria-hidden size={8} />,
  pending: <IoHourglassOutline aria-hidden />,
  stopped: <IoAlertCircle aria-hidden />,
};

/**
 * The candidate's status with its color, icon and label, so that it never relies on the color alone
 */
export const StatusChip: React.FC<{ status: CandidateStatusDto }> = ({ status }) => {
  const { t } = useTranslationWithPrefix('views.admin');
  const tone = statusTone(status);
  return (
    <span
      className="inline-flex max-w-full items-center gap-1.5 px-2 py-1 text-xs font-bold"
      style={{ ...TONE_STYLES[tone], borderRadius: 4 }}
    >
      {TONE_ICONS[tone]}
      <span className="truncate">{t(`table.statuses.${status}`)}</span>
    </span>
  );
};
